import { UserAdminPath, UserAdminTitle } from "@/entities";
import { AdminBreadcrumb, AdminTitle } from "@/shared";

export function AdminUserListPage() {
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={UserAdminPath} />
          <AdminTitle title={UserAdminTitle} />
        </div>
        <div className="ms-auto"></div>
      </div>
    </>
  );
}
